var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyvalue-wrapper"},[_vm._l((_vm.data),function(value,key){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(value))])])]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263e98f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/monitor/components/KeyValueList.vue
// module id = 419
// module chunks = 1